export function generateName(name: string, currencyISO: string) {
  return `${name} (${currencyISO})`;
}

export function generateDetails(
  provider: string | null,
  holdingsCount: number | undefined
) {
  return provider === '' || provider === null
    ? `${holdingsCount} holdings`
    : `Linked to ${provider}`;
}
